import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { useToast } from '@/components/ui/use-toast'
import { Eye, EyeOff } from 'lucide-react'
import { authService } from '@/services/authService'
import { useAuth } from '@/context/AuthContext'

const LoginPage = () => {
  const navigate = useNavigate()
  const { toast } = useToast()
  const { checkAuth } = useAuth()
  const [showPassword, setShowPassword] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(false)
  const [formData, setFormData] = React.useState({
    email: '',
    password: ''
  })

  React.useEffect(() => {
    const isAuth = authService.isAuthenticated()
    console.log('LoginPage - isAuthenticated:', isAuth)
    if (isAuth) {
      console.log('LoginPage - Redirecting to dashboard...')
      navigate('/dashboard')
    }
  }, [navigate])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsLoading(true)

    try {
      console.log('LoginPage - Attempting login...')
      const response = await authService.login(formData)
      console.log('LoginPage - Login successful:', response)
      
      // Auth durumunu güncelle
      checkAuth()
      
      toast({
        title: 'Başarılı',
        description: 'Giriş başarılı. Yönlendiriliyorsunuz...'
      })
      
      console.log('LoginPage - Navigating to dashboard...')
      navigate('/dashboard', { replace: true })
    } catch (error: any) {
      console.error('LoginPage - Login error:', error)
      toast({
        variant: 'destructive',
        title: 'Hata',
        description: error.response?.data?.error || 'Giriş yapılırken bir hata oluştu'
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="min-h-screen w-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-xl mx-auto">
        <div className="bg-card p-8 rounded-xl border border-border shadow-lg">
          {/* Logo ve Başlık */}
          <div className="text-center mb-8">
            <h1 className="text-2xl font-bold">Cloud Jukebox Manager</h1>
            <p className="text-muted-foreground mt-2">Süper Admin Paneli</p>
          </div>

          {/* Giriş Formu */}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block text-sm font-medium mb-2">
                Email Adresi
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full px-4 py-2 rounded-lg border border-border bg-background focus:outline-none focus:ring-2 focus:ring-primary/20"
                placeholder="ornek@email.com"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">
                Şifre
              </label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className="w-full px-4 py-2 rounded-lg border border-border bg-background focus:outline-none focus:ring-2 focus:ring-primary/20"
                  placeholder="••••••••"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
              </div>
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="w-full bg-primary text-primary-foreground py-2 rounded-lg hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isLoading ? 'Giriş Yapılıyor...' : 'Giriş Yap'}
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default LoginPage
